import {apiCreateCustomerFeedback }  from '@api/feedback-api'
import { Message, MessageBox } from 'element-ui'
import store from '@/store/index'
import i18n from '@/helper/i18n'
import router from '../../router'

const user = {
    namespaced: true,
    state: {
        feedbackType: null,
        comment: null,
        rating: null,
        uniqueOrderCode : null,
        branchUUId : null,
        iconClose : Boolean,
    },
    getters: {
        feedbackType(state) {
            return state.feedbackType;
        },
        comment(state) {
            return state.comment;
        },
        rating(state) {
            return state.rating;
        },
        uniqueOrderCode(state) {
            return state.uniqueOrderCode;
        },
        branchUUId(state) {
            return state.branchUUId;
        },
        iconClose(state){
            return state.iconClose;
        },
    },
    mutations: {
        SET_FEEDBACK_TYPE(state, feedbackType) {
            state.feedbackType = feedbackType;
        },
        SET_COMMENT(state, comment) {
            state.comment = comment;
        },
        SET_RATING(state, rating){
            state.rating = rating;
        },
        SET_UOC(state, uniqueOrderCode) {
            state.uniqueOrderCode = uniqueOrderCode;
        },
        SET_BRANCH(state,branchUUId){
            state.branchUUId = branchUUId;
        },
        SET_ICON(state,iconClose){
            state.iconClose = iconClose;
        },
    },
    actions: {
        async createCustomerFeedback ({ commit, dispatch }) {
            return await apiCreateCustomerFeedback({
                branch_uuid :store.getters['feedback/branchUUId'],
                uoc : store.getters['feedback/uniqueOrderCode'],
                feedback_type_id : store.getters['feedback/feedbackType'],
                comment : store.getters['feedback/comment'],
                rating : store.getters['feedback/rating'],
            })
                .then(async (response) => {
                    if(response.data.code == 200){
                        router.push({ name: "thankUForfeedback" });
                    }
                    else{
                        Message.error({ duration: 2000, message: i18n.t('customer-feedback.error-creat') });
                        router.push({
                            name: "Home",
                            params: {
                                restaurant_aliase: store.getters["restaurant/restaurantUUID"],
                                branch_aliase: store.getters["branch/branchUUID"],
                            },
                        })
                    }   
                })
                .catch(async (error) => {
                    router.push({
                        name: "Home",
                        params: {
                            restaurant_aliase: store.getters["restaurant/restaurantUUID"],
                            branch_aliase: store.getters["branch/branchUUID"],
                        },
                    })
                })
                .finally(() => {
                    dispatch('clearUserData');
                });
        },
        clearUserData({commit}) {
            commit("SET_FEEDBACK_TYPE", null);
            commit("SET_COMMENT", null);
            commit("SET_RATING", null);
            commit("SET_UOC", null);
            commit("SET_BRANCH", null);
        }
    }
}

export default user
